import IconExternal from "../../../public/image/svg/external.svg";
import styles from "../C37.5_EventDetail.module.scss";

const LinksSection = (props: { links: any[] }) => {
  const { links } = props;

  return (
    <ul className={styles["link-list"]}>
      {links.map((link, index) => (
        <li key={`link-${index}`}>
          <IconExternal className={styles["icon-external"]} aria-hidden />
          <a href={link.eventRelatedUrlValue} target="_blank" rel="noreferrer">
            {link.eventRelatedUrlDescription}
          </a>
        </li>
      ))}
    </ul>
  );
};

export default LinksSection;
